module.exports = __webpack_public_path__ + "img/mspo.5b8a90b8.svg";